function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 4.9995509e-05 199.378186 4.9995509e-05 199.378186 140 0 140"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 140 207.527 140 207.527 0 0 0"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uikit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "kit",
  transform: "translate(-916.000000, -2673.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-82",
  transform: "translate(916.000000, 2673.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.418,137.6264 C47.195,136.9134 -3.538,130.4944 0.196,83.1524 C3.931,35.8114 8.618,21.5734 28.343,16.3654 C48.067,11.1564 96.015,-13.4906 133.639,9.9444 C171.264,33.3804 211.862,54.3994 195.752,91.8194 C179.641,129.2404 177.003,141.7234 134.968,139.8134 C92.933,137.9024 71.497,141.0154 51.418,137.6264",
  id: "Fill-1",
  fill: "#F5F8FF",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.587,33.683 L89.9,33.683 C92.998,33.683 95.533,36.217 95.533,39.316 C95.533,42.414 92.998,44.949 89.9,44.949 L20.587,44.949 C17.489,44.949 14.954,42.414 14.954,39.316 C14.954,36.217 17.489,33.683 20.587,33.683",
  id: "Fill-4",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8174,48.8383 L42.3614,48.8383 C44.8334,48.8383 46.8544,50.8603 46.8544,53.3313 C46.8544,55.8033 44.8334,57.8243 42.3614,57.8243 L13.8174,57.8243 C11.3464,57.8243 9.3244,55.8033 9.3244,53.3313 C9.3244,50.8603 11.3464,48.8383 13.8174,48.8383",
  id: "Fill-6",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.4766,21.2094 L37.0206,21.2094 C39.4926,21.2094 41.5136,23.2304 41.5136,25.7024 C41.5136,28.1734 39.4926,30.1954 37.0206,30.1954 L8.4766,30.1954 C6.0056,30.1954 3.9836,28.1734 3.9836,25.7024 C3.9836,23.2304 6.0056,21.2094 8.4766,21.2094",
  id: "Fill-8",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.4707,29.8373 C24.8627,29.8373 25.9907,30.6983 25.9907,31.7603 C25.9907,32.8213 24.8627,33.6833 23.4707,33.6833 L34.4637,33.6833 C33.0727,33.6833 31.9447,32.8213 31.9447,31.7603 C31.9447,30.6983 33.0727,29.8373 34.4637,29.8373 L23.4707,29.8373 Z",
  id: "Fill-10",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9092,44.8256 C21.3612,44.8256 22.5392,45.7236 22.5392,46.8316 C22.5392,47.9396 21.3612,48.8386 19.9092,48.8386 L31.3852,48.8386 C29.9322,48.8386 28.7552,47.9396 28.7552,46.8316 C28.7552,45.7236 29.9322,44.8256 31.3852,44.8256 L19.9092,44.8256 Z",
  id: "Fill-12",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.9239,95.0395 L121.6109,95.0395 C118.5129,95.0395 115.9779,92.5045 115.9779,89.4065 C115.9779,86.3085 118.5129,83.7725 121.6109,83.7725 L190.9239,83.7725 C194.0219,83.7725 196.5569,86.3085 196.5569,89.4065 C196.5569,92.5045 194.0219,95.0395 190.9239,95.0395",
  id: "Fill-14",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.6934,79.8832 L169.1494,79.8832 C166.6774,79.8832 164.6564,77.8622 164.6564,75.3902 C164.6564,72.9192 166.6774,70.8972 169.1494,70.8972 L197.6934,70.8972 C200.1644,70.8972 202.1854,72.9192 202.1854,75.3902 C202.1854,77.8622 200.1644,79.8832 197.6934,79.8832",
  id: "Fill-16",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.0342,107.5131 L174.4902,107.5131 C172.0182,107.5131 169.9972,105.4911 169.9972,103.0201 C169.9972,100.5481 172.0182,98.5271 174.4902,98.5271 L203.0342,98.5271 C205.5052,98.5271 207.5262,100.5481 207.5262,103.0201 C207.5262,105.4911 205.5052,107.5131 203.0342,107.5131",
  id: "Fill-18",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.0401,98.8842 C186.6481,98.8842 185.5201,98.0242 185.5201,96.9612 C185.5201,95.9002 186.6481,95.0392 188.0401,95.0392 L177.0461,95.0392 C178.4371,95.0392 179.5651,95.9002 179.5651,96.9612 C179.5651,98.0242 178.4371,98.8842 177.0461,98.8842 L188.0401,98.8842 Z",
  id: "Fill-20",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.6016,83.8969 C190.1486,83.8969 188.9716,82.9989 188.9716,81.8899 C188.9716,80.7819 190.1486,79.8829 191.6016,79.8829 L180.1256,79.8829 C181.5786,79.8829 182.7556,80.7819 182.7556,81.8899 C182.7556,82.9989 181.5786,83.8969 180.1256,83.8969 L191.6016,83.8969 Z",
  id: "Fill-22",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.5401,110.2123 L72.1111,110.2123 C56.0911,110.2123 43.1041,97.2253 43.1041,81.2053 C43.1041,65.1853 56.0911,52.1983 72.1111,52.1983 L100.5401,52.1983 C116.5611,52.1983 129.5471,65.1853 129.5471,81.2053 C129.5471,97.2253 116.5611,110.2123 100.5401,110.2123",
  id: "Fill-24",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.2178,52.5287 C46.4778,52.5287 43.4348,55.5717 43.4348,59.3117 L43.4348,103.0987 C43.4348,106.8397 46.4778,109.8827 50.2178,109.8827 L122.4338,109.8827 C126.1738,109.8827 129.2168,106.8397 129.2168,103.0987 L129.2168,59.3117 C129.2168,55.5717 126.1738,52.5287 122.4338,52.5287 L50.2178,52.5287 Z M122.4338,110.5427 L50.2178,110.5427 C46.1138,110.5427 42.7738,107.2037 42.7738,103.0987 L42.7738,59.3117 C42.7738,55.2077 46.1138,51.8677 50.2178,51.8677 L122.4338,51.8677 C126.5378,51.8677 129.8778,55.2077 129.8778,59.3117 L129.8778,103.0987 C129.8778,107.2037 126.5378,110.5427 122.4338,110.5427 L122.4338,110.5427 Z",
  id: "Fill-26",
  fill: "#6E87FF"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-29"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-28",
  fill: "#A9BCFF",
  mask: "url(#mask-4)",
  points: "44.964 83.12 131.406 83.12 131.406 67.104 44.964 67.104"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.435,80.929 L129.217,80.929 L129.217,65.575 L43.435,65.575 L43.435,80.929 Z M129.547,81.59 L43.105,81.59 C42.922,81.59 42.773,81.442 42.773,81.26 L42.773,65.245 C42.773,65.062 42.922,64.914 43.105,64.914 L129.547,64.914 C129.73,64.914 129.878,65.062 129.878,65.245 L129.878,81.26 C129.878,81.442 129.73,81.59 129.547,81.59 L129.547,81.59 Z",
  id: "Fill-30",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.9991,106.9506 L108.5501,106.9506 C108.3671,106.9506 108.2191,106.8026 108.2191,106.6196 C108.2191,106.4376 108.3671,106.2896 108.5501,106.2896 L113.9991,106.2896 C114.1821,106.2896 114.3291,106.4376 114.3291,106.6196 C114.3291,106.8026 114.1821,106.9506 113.9991,106.9506",
  id: "Fill-31",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.9493,106.9506 L91.0953,106.9506 C90.9133,106.9506 90.7643,106.8026 90.7643,106.6196 C90.7643,106.4376 90.9133,106.2896 91.0953,106.2896 L94.9493,106.2896 C95.1323,106.2896 95.2793,106.4376 95.2793,106.6196 C95.2793,106.8026 95.1323,106.9506 94.9493,106.9506",
  id: "Fill-32",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.0264,106.9506 L81.7764,106.9506 C81.5934,106.9506 81.4464,106.8026 81.4464,106.6196 C81.4464,106.4376 81.5934,106.2896 81.7764,106.2896 L89.0264,106.2896 C89.2094,106.2896 89.3564,106.4376 89.3564,106.6196 C89.3564,106.8026 89.2094,106.9506 89.0264,106.9506",
  id: "Fill-33",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.3008,104.1069 C48.1758,104.1069 48.0568,104.0359 48.0008,103.9149 C47.4478,102.7109 47.4548,101.4149 47.4618,100.1609 C47.4618,100.0229 47.4628,99.8849 47.4628,99.7469 C47.4628,99.5639 47.6118,99.4169 47.7928,99.4169 C47.9758,99.4169 48.1238,99.5639 48.1238,99.7469 C48.1238,99.8859 48.1228,100.0249 48.1218,100.1639 C48.1158,101.4009 48.1098,102.5689 48.6018,103.6379 C48.6778,103.8039 48.6048,104.0009 48.4388,104.0769 C48.3948,104.0969 48.3478,104.1069 48.3008,104.1069",
  id: "Fill-34",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.6817,106.8647 C51.6557,106.8647 51.6287,106.8617 51.6027,106.8547 C50.7177,106.6367 49.8937,106.1927 49.2207,105.5727 C49.0857,105.4487 49.0777,105.2397 49.2017,105.1057 C49.3257,104.9707 49.5347,104.9637 49.6677,105.0867 C50.2597,105.6327 50.9837,106.0217 51.7607,106.2147 C51.9377,106.2577 52.0457,106.4367 52.0017,106.6137 C51.9647,106.7637 51.8297,106.8647 51.6817,106.8647",
  id: "Fill-35",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.2149,89.726 L96.7859,89.726 C80.7659,89.726 67.7789,76.739 67.7789,60.719 C67.7789,44.699 80.7659,31.712 96.7859,31.712 L125.2149,31.712 C141.2359,31.712 154.2219,44.699 154.2219,60.719 C154.2219,76.739 141.2359,89.726 125.2149,89.726",
  id: "Fill-36",
  fill: "#FFFFFF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8926,32.0424 C71.1526,32.0424 68.1096,35.0854 68.1096,38.8254 L68.1096,82.6124 C68.1096,86.3534 71.1526,89.3964 74.8926,89.3964 L147.1086,89.3964 C150.8486,89.3964 153.8916,86.3534 153.8916,82.6124 L153.8916,38.8254 C153.8916,35.0854 150.8486,32.0424 147.1086,32.0424 L74.8926,32.0424 Z M147.1086,90.0564 L74.8926,90.0564 C70.7886,90.0564 67.4486,86.7174 67.4486,82.6124 L67.4486,38.8254 C67.4486,34.7214 70.7886,31.3814 74.8926,31.3814 L147.1086,31.3814 C151.2126,31.3814 154.5526,34.7214 154.5526,38.8254 L154.5526,82.6124 C154.5526,86.7174 151.2126,90.0564 147.1086,90.0564 L147.1086,90.0564 Z",
  id: "Fill-37",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.6641,82.0131 L75.1511,82.0131 C74.9691,82.0131 74.8211,81.8661 74.8211,81.6831 C74.8211,81.5001 74.9691,81.3531 75.1511,81.3531 L105.6641,81.3531 C105.8471,81.3531 105.9951,81.5001 105.9951,81.6831 C105.9951,81.8661 105.8471,82.0131 105.6641,82.0131",
  id: "Fill-38",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.6641,39.1567 L75.1511,39.1567 C74.9691,39.1567 74.8211,39.0087 74.8211,38.8267 C74.8211,38.6437 74.9691,38.4957 75.1511,38.4957 L105.6641,38.4957 C105.8471,38.4957 105.9951,38.6437 105.9951,38.8267 C105.9951,39.0087 105.8471,39.1567 105.6641,39.1567",
  id: "Fill-39",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.5342,46.8744 C146.5342,42.7154 143.1622,39.3444 139.0042,39.3444 C134.8452,39.3444 131.4722,42.7154 131.4722,46.8744 C131.4722,51.0334 134.8452,54.4044 139.0042,54.4044 C143.1622,54.4044 146.5342,51.0334 146.5342,46.8744",
  id: "Fill-40",
  fill: "#A9BCFF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.9561,46.8744 C140.9561,42.7154 137.5841,39.3444 133.4251,39.3444 C129.2671,39.3444 125.8941,42.7154 125.8941,46.8744 C125.8941,51.0334 129.2671,54.4044 133.4251,54.4044 C137.5841,54.4044 140.9561,51.0334 140.9561,46.8744",
  id: "Fill-41",
  fill: "#A9BCFF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.8877,53.6196 C137.7047,53.6196 137.5577,53.4726 137.5577,53.2896 C137.5577,53.1066 137.7047,52.9596 137.8877,52.9596 C141.8587,52.9596 145.0877,49.7286 145.0877,45.7596 C145.0877,41.7886 141.8587,38.5586 137.8877,38.5586 C137.7047,38.5586 137.5577,38.4106 137.5577,38.2276 C137.5577,38.0466 137.7047,37.8976 137.8877,37.8976 C142.2227,37.8976 145.7487,41.4246 145.7487,45.7596 C145.7487,50.0936 142.2227,53.6196 137.8877,53.6196",
  id: "Fill-42",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.3096,38.559 C128.3386,38.559 125.1096,41.788 125.1096,45.759 C125.1096,49.729 128.3386,52.959 132.3096,52.959 C136.2796,52.959 139.5096,49.729 139.5096,45.759 C139.5096,41.788 136.2796,38.559 132.3096,38.559 M132.3096,53.62 C127.9746,53.62 124.4486,50.093 124.4486,45.759 C124.4486,41.424 127.9746,37.898 132.3096,37.898 C136.6446,37.898 140.1706,41.424 140.1706,45.759 C140.1706,50.093 136.6446,53.62 132.3096,53.62",
  id: "Fill-43",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.3946,59.4653 L83.0236,59.4653 C79.3606,59.4653 76.3906,56.4963 76.3906,52.8333 C76.3906,49.1703 79.3606,46.2003 83.0236,46.2003 L87.3946,46.2003 C91.0576,46.2003 94.0276,49.1703 94.0276,52.8333 C94.0276,56.4963 91.0576,59.4653 87.3946,59.4653",
  id: "Fill-44",
  fill: "#A9BCFF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.8301,45.434 C76.5351,45.434 75.4811,46.488 75.4811,47.783 L75.4811,55.69 C75.4811,56.985 76.5351,58.038 77.8301,58.038 L90.1091,58.038 C91.4031,58.038 92.4571,56.985 92.4571,55.69 L92.4571,47.783 C92.4571,46.488 91.4031,45.434 90.1091,45.434 L77.8301,45.434 Z M90.1091,58.699 L77.8301,58.699 C76.1711,58.699 74.8211,57.349 74.8211,55.69 L74.8211,47.783 C74.8211,46.123 76.1711,44.774 77.8301,44.774 L90.1091,44.774 C91.7681,44.774 93.1181,46.123 93.1181,47.783 L93.1181,55.69 C93.1181,57.349 91.7681,58.699 90.1091,58.699 L90.1091,58.699 Z",
  id: "Fill-45",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-46",
  fill: "#A9BCFF",
  mask: "url(#mask-4)",
  points: "75.31 73.866 91.006 73.866 91.006 67.787 75.31 67.787"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-47",
  fill: "#A9BCFF",
  mask: "url(#mask-4)",
  points: "93.637 73.866 109.334 73.866 109.334 67.787 93.637 67.787"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-48",
  fill: "#A9BCFF",
  mask: "url(#mask-4)",
  points: "112.145 73.866 127.842 73.866 127.842 67.787 112.145 67.787"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-49",
  fill: "#A9BCFF",
  mask: "url(#mask-4)",
  points: "130.995 73.866 146.692 73.866 146.692 67.787 130.995 67.787"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.0069,73.2065 L75.3089,73.2065 C75.1269,73.2065 74.9789,73.0595 74.9789,72.8765 C74.9789,72.6935 75.1269,72.5465 75.3089,72.5465 L91.0069,72.5465 C91.1889,72.5465 91.3369,72.6935 91.3369,72.8765 C91.3369,73.0595 91.1889,73.2065 91.0069,73.2065",
  id: "Fill-50",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.6924,73.2065 L130.9954,73.2065 C130.8124,73.2065 130.6644,73.0595 130.6644,72.8765 C130.6644,72.6935 130.8124,72.5465 130.9954,72.5465 L146.6924,72.5465 C146.8744,72.5465 147.0224,72.6935 147.0224,72.8765 C147.0224,73.0595 146.8744,73.2065 146.6924,73.2065",
  id: "Fill-51",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.0733,73.2065 L112.3763,73.2065 C112.1933,73.2065 112.0463,73.0595 112.0463,72.8765 C112.0463,72.6935 112.1933,72.5465 112.3763,72.5465 L128.0733,72.5465 C128.2563,72.5465 128.4033,72.6935 128.4033,72.8765 C128.4033,73.0595 128.2563,73.2065 128.0733,73.2065",
  id: "Fill-52",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.5293,73.2065 L93.8313,73.2065 C93.6493,73.2065 93.5013,73.0595 93.5013,72.8765 C93.5013,72.6935 93.6493,72.5465 93.8313,72.5465 L109.5293,72.5465 C109.7113,72.5465 109.8593,72.6935 109.8593,72.8765 C109.8593,73.0595 109.7113,73.2065 109.5293,73.2065",
  id: "Fill-53",
  fill: "#6E87FF",
  mask: "url(#mask-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-54",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "170.428 58.666 171.419 58.666 171.419 56.211 170.428 56.211"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-55",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "170.428 63.639 171.419 63.639 171.419 61.184 170.428 61.184"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-56",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "167.194 60.405 169.649 60.405 169.649 59.415 167.194 59.415"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-57",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "172.167 60.405 174.622 60.405 174.622 59.415 172.167 59.415"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-58",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "44.364 14.065 45.354 14.065 45.354 11.611 44.364 11.611"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-59",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "44.364 19.038 45.354 19.038 45.354 16.583 44.364 16.583"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-60",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "41.13 15.804 43.585 15.804 43.585 14.813 41.13 14.813"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-61",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "46.102 15.804 48.557 15.804 48.557 14.813 46.102 14.813"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-62",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "152.614 112.71 153.605 112.71 153.605 110.255 152.614 110.255"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-63",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "152.614 117.683 153.605 117.683 153.605 115.228 152.614 115.228"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-64",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "149.38 114.45 151.835 114.45 151.835 113.459 149.38 113.459"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-65",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "154.353 114.45 156.808 114.45 156.808 113.459 154.353 113.459"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-66",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "19.429 84.913 20.42 84.913 20.42 82.458 19.429 82.458"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-67",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "19.429 89.886 20.42 89.886 20.42 87.431 19.429 87.431"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-68",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "16.195 86.653 18.65 86.653 18.65 85.662 16.195 85.662"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-69",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "21.168 86.653 23.623 86.653 23.623 85.662 21.168 85.662"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-70",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "155.1 14.545 156.091 14.545 156.091 12.09 155.1 12.09"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-71",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "155.1 19.517 156.091 19.517 156.091 17.062 155.1 17.062"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-72",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "151.866 16.284 154.321 16.284 154.321 15.293 151.866 15.293"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-73",
  fill: "#FF9C80",
  mask: "url(#mask-4)",
  points: "156.839 16.284 159.294 16.284 159.294 15.293 156.839 15.293"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-74",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "91.11 20.234 92.101 20.234 92.101 17.779 91.11 17.779"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-75",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "91.11 25.206 92.101 25.206 92.101 22.751 91.11 22.751"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-76",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "87.876 21.972 90.331 21.972 90.331 20.981 87.876 20.981"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-77",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "92.849 21.972 95.304 21.972 95.304 20.981 92.849 20.981"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-78",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "74.01 125.285 75.001 125.285 75.001 122.83 74.01 122.83"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-79",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "74.01 130.257 75.001 130.257 75.001 127.802 74.01 127.802"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-80",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "70.777 127.023 73.231 127.023 73.231 126.033 70.777 126.033"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-81",
  fill: "#6E87FF",
  mask: "url(#mask-4)",
  points: "75.749 127.023 78.204 127.023 78.204 126.033 75.749 126.033"
}))));

var SvgKredikarti = function SvgKredikarti(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "208px",
    height: "140px",
    viewBox: "0 0 208 140",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKredikarti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kredikarti.b49f7f38.svg";
export { ForwardRef as ReactComponent };